<template>
  <div class="shadow-box-title-description">
    <ShadowBox
      v-if="title"
      class="shadow-box"
      :class="{'left_text': isLeftText, 'sp_font_size': isSpFontSize}"
      opacity="_60"
    >
      <span class="text">{{title}}</span>
    </ShadowBox>
    <slot></slot>
  </div>
</template>

<script>
import ShadowBox from '@/components/atoms/ShadowBox.vue';

export default {
  name: 'ShadowBoxTitleDescription',

  components: {
    ShadowBox,
  },

  props: {
    title: {
      type: String,
    },
    isLeftText: {
      type: Boolean,
      default: false,
    },
    isSpFontSize: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.shadow-box-title-description{
  .shadow-box{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 30px;
    padding: 6px 0;
    background-color: $mainColor;
    text-align: center;
    .text{
      font-family: $notoSans;
      font-size: 20px;
      font-weight: bold;
      color: $white;
      padding: 4px 0;
      border-radius: 100px;
    }
  }
  .shadow-box.left_text {
    justify-content: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .shadow-box-title-description {
    .shadow-box {
      justify-content: left;
      padding-left: 10px;
      text-align: left;
      .text {
        font-size: 14px;
      }
    }
  }
}
</style>
